<div
  *ngIf="title"
  class="flex justify-between divider-line1 border-b-gray-300 pb-[10px]"
>
  <p class="flex-1 text-gray-700">{{ title }}</p>
  <p class="flex-1 text-black font-semibold">{{ text }}</p>
</div>
